<template>
  <div class="expertDetails">
    <div class="expertBox">
      <div class="expertDetails">
        <el-image :src="objData.head" fit="fill"></el-image>
      </div>
      <div class="expertDetailsrightText">
        <div class="title">{{ objData.name }}</div>
        <div class="small-title">{{ objData.company }}</div>
        <div class="line"></div>
        <div class="text" v-html="objData.detail"></div>
      </div>
    </div>
    <div class="he50"></div>
    <div class="he50"></div>
  </div>
</template>

<script>
import { getExpertShowDetail } from "@/api/api.js";

export default {
  data() {
    return {
      objData: {
        company: "",
        createTime: "",
        detail: "",
        head: "",
        id: "2",
        introduction: "",
        lastUpdateTime: "",
        name: "",
        sort: ""
      }
    };
  },
  mounted() {
    this.toPage(this.$route.query.id);
  },
  methods: {
    toPage(id) {
      if (id) {
        this.getExpertShowDetail(id);
      } else {
        this.$router.push({ name: "H5expert" });
      }
    },
    getExpertShowDetail(id) {
      getExpertShowDetail(id).then(res => {
        if (res.code === 0) {
          this.objData = {
            company: res.data.company,
            createTime: res.data.createTime,
            detail: res.data.detail,
            head: res.data.head,
            id: res.data.id,
            introduction: res.data.introduction,
            lastUpdateTime: res.data.lastUpdateTime,
            name: res.data.name,
            sort: res.data.sort
          };
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    toLink(id) {
      this.getNewsDetail(id);
    }
  }
};
</script>

<style lang="less">
.expertDetails {
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  .expertBox {
    .expertDetails {
      width: 100%;
      text-align: center;
    }
    .expertDetailsrightText {
      width: 100%;
      .title {
        font-size: 18px;
        font-weight: bold;
        color: rgba(52, 52, 52, 1);
        line-height: 40px;
        text-align: center;
      }
      .small-title {
        font-size: 14px;
        font-family: PingFang;
        font-weight: 400;
        color: rgba(52, 52, 52, 1);
        line-height: 20px;
        text-align: center;
      }
      .line {
        margin: 10px auto;
        width: 30px;
        height: 3px;
        background: rgba(108, 44, 102, 1);
      }
      .text {
        font-size: 16px;
        color: rgba(52, 52, 52, 1);
        line-height: 24px;
      }
    }
  }
}
</style>
